import * as yup from "yup";

export const buyPowerSchema = yup.object().shape({
    amount: yup.number().required("Amount is required").min(0, "Amount cannot be 0"),
});

export const buyPowerAdminSchema = yup.object().shape({
    amount: yup.number().required("Amount is required").min(0, "Amount cannot be 0"),
    meterNumber: yup.string().required("Meter Number is required").min(6, "Meter Number must be at least 6 characters"),
});
